<template>
  <div class='withdraw-detail'>
    <div class='withdraw-top'>
      <div class='top-titile'>
        <div>账户余额 (元)</div>
      </div>
      <div class='withdraw-yue'>
        <span>{{amount | formatMoneyStutas}}</span>
      </div>
      <div class='withdraw-peo'>
        <div class='w-nav' @click="checkDetail">查看明细</div>
      </div>
    </div>
    <div class='withdraw-bg'>
      <img src='@/assets/image/withdraw-bg.png'/>
    </div>
  </div>
</template>

<script>
import numeral from 'numeral'

export default {
  props: {
    amount: {
      type: [Number, String],
      default: 0
    }
  },
  methods: {
    checkDetail () {
      this.$emit('checkDetail')
    }
  },
  filters: {
    formatMoneyStutas (value) {
      if (value) {
        return numeral(value).format('0,0.00')
      } else {
        return '0.00'
      }
    }
  }
}
</script>

<style scoped>
  .withdraw-detail{
    position: relative;
    border-radius:10px;
    height: 24.5vh;
    margin: 3% 3%;
    padding: 3% 4%;
    background: #313131;
  }
  .withdraw-top{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    padding: 3% 4%;
    box-sizing: border-box;
    color: #fff;
    width: 100%;
    height: 100%;
  }
  .withdraw-top .top-titile{
    display: flex;
    justify-content:space-between;
    width: 100%;
    height: 30px;
    line-height: 30px;
    z-index: 10;
  }
  .withdraw-bg{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    width: 100%;
    height: 100%;
  }
  .withdraw-bg img{
    width: 100%;
    height: 100%;
  }
  .withdraw-peo{
    position: absolute;
    top: initial;
    left: initial;
    bottom: 6%;
    right: 4%;
    z-index: 10;
  }
  .w-nav{
    height: 28px;
    line-height: 28px;
    padding: 0 10px;
    border: 1px solid #fff;
    border-radius: 4px;
  }
  .withdraw-yue{
    font-size: 10.5vw;
    font-weight: bold;
    z-index: 10;
  }
  @media screen and (height: 812px) {
    .withdraw-detail{
      height: 21vh;
    }
  }
</style>
